const video = $(".video");
const mobileVideoID = $('video-js').attr('data-video-id-mobile');
const isMobileDeviceWithTablet = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|iPad/i.test(navigator.userAgent);

//- Handle About Section Dom position for mobile and desktop
const vslContainer = $('#vslSectionVsl');
const vslCta = $('#VSLCta');
const vslPlayCta = $('#playCTA');
const videoPlayer = videojs('vslSectionVsl');
const breakPoint = 768;

let windowW = window.innerWidth;
let isPlaying = false;

function addCookie() {
  videojs($('.video-js').attr('id')).ready(function () {
    this.on('timeupdate', function () {
      if (this.currentTime() >= (60 * timePlaying) || this.currentTime() == this.duration()) {
        vslCta.removeClass('hide');
      }
    })
  });
  $.cookie("oliveoil-prelander-rc", 1, { expires: 7 });
}

//- Handle cookies for VSL Play button
if (!$.cookie('oliveoil-prelander-rc')) addCookie();
else vslCta.removeClass('hide');

vslPlayCta.on('click', function () {
  videoPlayer.play();
  hideVideoPlayButton();

  if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithTablet ||
    typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithTablet) {
    fullScreenVsl();
  } else if (isMobileDeviceWithTablet) {
    if (isPlaying) {
      videoPlayer.pause();
      $('.vjs-big-play-button').show();
    } else { 
      videoPlayer.play();
      $('.vjs-big-play-button').hide();
    }

    isPlaying = !isPlaying;
  }
})

function hideVideoPlayButton() {
  vslPlayCta.hide();
}

//- Full screen VSL
function fullScreenVsl() {
  if ($('body').hasClass('fullScreenVsl')) {
    videoPlayer.pause();
    $('.vjs-big-play-button').show();
    $('body').removeClass('fullScreenVsl');
    return
  } else {
    const videoTop = document.getElementById('vslSectionVsl').getBoundingClientRect().top;

    window.scrollBy({
      top: videoTop,
      left: 0,
      behavior: 'smooth'
    });
  
    videoPlayer.play();
    $('.vjs-big-play-button').hide();
    $('body').addClass('fullScreenVsl');
  };
}

const handleFullScreenInline = videoEl => {
  let startScrollTop,
      endScrollTop;

  videoEl.on("touchstart", function () {
    startScrollTop = $(window).scrollTop();
  });

  videoEl.on('touchend', function () {
    endScrollTop = $(window).scrollTop();
  });

  videoEl.on('click touchend', function () {
    if (startScrollTop === endScrollTop) {
      fullScreenVsl();
    }
  });

  videoEl.one('click touchend', function () {
    hideVideoPlayButton();
  });
}

const videoPlayPause = (videoEl) => {
  let startScrollTop,
      endScrollTop;

  videoEl.on("touchstart", function () {
    startScrollTop = $(window).scrollTop();
  });

  videoEl.on('touchend', function () {
    endScrollTop = $(window).scrollTop();
  });

  videoEl.on('click touchend', function () {
    if (startScrollTop === endScrollTop) {
      if (isPlaying) {
        videoPlayer.pause();
        $('.vjs-big-play-button').show();
      } else {
        videoPlayer.play();

        hideVideoPlayButton();
        $('.vjs-big-play-button').hide();
      }

      isPlaying = !isPlaying;
    }
  });
}

if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithTablet ||
  typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithTablet) {
  handleFullScreenInline(video);
} else if (isMobileDeviceWithTablet) {
  videoPlayPause(video);
}